import React, { useState, useEffect } from "react"
import { FormattedMessage, useIntl } from "react-intl"
import { Button, ButtonGroup } from "react-bootstrap"

import { withSampleConfig } from "../../../config/SampleConfigProvider"
import { API_STATUS } from "../../../shared_components/widgets/utils"
import PageLoadingPanel from "../../../shared_components/widgets/PageLoadingPanel"
import PageErrorPanel from "../../../shared_components/widgets/PageErrorPanel"
import { LanzaTable } from "../../../shared_components/widgets/LanzaTable"
import { hideModal, showModal } from "../../../shared_components/utils"
import OfflineFileLogModal from "./OfflineFileLogModal"
import { LocaleFormattedDate } from "../../internationalization/LocaleFormatted"

const ManageOfflineFilesTab = ({
  getExternalSampleJSON, // From SampleConfigProvider
  sample_external_json, // From SampleConfigProvider
  sample_external_json_status, // From SampleConfigProvider
}) => {
  const intl = useIntl()
  const [data, setData] = useState([])
  const [status, setStatus] = useState(API_STATUS.LOADING)
  const [showLogModal, setShowLogModal] = useState(false)
  const [selectedSample, setSelectedSample] = useState({})

  useEffect(() => {
    getExternalSampleJSON()
  }, [])

  useEffect(() => {
    let external_json = []
    Array.isArray(sample_external_json) &&
      sample_external_json.forEach((json) => {
        let info = {
          created_on: json.created_on,
          last_modified_on: json.last_modified_on,
        }
        const process_msgs = Object.values(json["processing_msg"] || {})
        Array.isArray(json["passed_json"]) &&
          json["passed_json"].forEach((smp) => {
            const msg_log = process_msgs.find((log) => log.name === smp.sample_id) || {}
            external_json.push({
              ...info,
              file_path: smp["filePath"] || "-",
              sample_id: smp["sample_id"] || "-",
              sample_source_type: smp["sample_source_type"] || "-",
              sampling_time: smp["sampling_time"] || "-",
              method_name: smp["method_name"] || "-",
              test_items: smp["test_items"] || "-",
              log_status: msg_log.status || "-",
              log_message: msg_log.message || "-",
              log_detail: msg_log.detail || {},
            })
          })
      })
    setData(external_json)
  }, [sample_external_json])

  useEffect(() => {
    setStatus(sample_external_json_status)
  }, [sample_external_json_status])

  return (
    <>
      <div className={"row"}>
        <div className={"col-6"} />
        <div className={"col-6"} align={"right"}>
          <Button
            variant={"outline-primary"}
            onClick={() => getExternalSampleJSON()}
            style={{ marginRight: "10px" }}
          >
            <span className={"fa fa-refresh"} />
            &nbsp;&nbsp;
            <FormattedMessage id={"general.refresh"} description={"Sample JSON Refresh Data Button"} />
          </Button>
        </div>
      </div>
      <hr style={{ margin: "10px 0px 25px 0px" }} />
      <>
        {status === API_STATUS.LOADING && <PageLoadingPanel />}
        {status === API_STATUS.ERROR && <PageErrorPanel attemptReload={getExternalSampleJSON} />}
        {status === API_STATUS.SUCCESS && (
          <div>
            <LanzaTable
              name={"Sample Offline Files Table"}
              className={"table table-bordered table-sm table-hover tbl_lanzatable"}
              columns={[
                {
                  Header: <FormattedMessage id={"general.updated.on"} />,
                  id: "last_modified_on",
                  accessor: "last_modified_on",
                  disableFilters: true,
                  Cell: ({ value }) => (value ? <LocaleFormattedDate date={value} /> : "-"),
                  className: "text-center",
                },
                {
                  Header: <FormattedMessage id={"samplemanagement.sample.id"} />,
                  id: "sample_id",
                  accessor: "sample_id",
                  className: "text-center",
                },
                {
                  Header: <FormattedMessage id={"samplemanagement.sample.source.type"} />,
                  id: "sample_source_type",
                  accessor: "sample_source_type",
                  className: "text-center",
                },
                {
                  Header: <FormattedMessage id={"general.time"} defaultMessage={"Time"} />,
                  id: "sampling_time",
                  accessor: "sampling_time",
                  disableFilters: true,
                  Cell: ({ value }) =>
                    value && value !== "-" ? <LocaleFormattedDate date={value} shouldParse={true} /> : "-",
                  className: "text-center",
                },
                {
                  Header: <FormattedMessage id={"general.status"} />,
                  id: "log_status",
                  accessor: "log_status",
                  className: "text-center",
                },
                {
                  Header: <FormattedMessage id={"datatransfer.column.message"} defaultMessage={"Message"} />,
                  id: "log_message",
                  accessor: "log_message",
                  style: { maxWidth: "200px", minWidth: "200px" },
                  className: "text-center",
                },
                {
                  Header: <FormattedMessage id={"general.log"} />,
                  id: "logs",
                  disableSortBy: true,
                  disableFilters: true,
                  accessor: (smp) => {
                    return (
                      <ButtonGroup>
                        <Button
                          variant={"outline-primary"}
                          size={"sm"}
                          onClick={(e) => {
                            e.preventDefault()
                            showModal(setShowLogModal)
                            setSelectedSample(smp)
                          }}
                          title={intl.formatMessage({
                            id: "general.log",
                          })}
                        >
                          <span className={"fa fa-align-justify"} />
                        </Button>
                      </ButtonGroup>
                    )
                  },
                  className: "text-center",
                },
              ]}
              data={data}
              allowSorting={true}
              allowFilters={true}
              allowRowSelection={false}
              initialTableOptions={{
                pageSize: 30,
              }}
            />
          </div>
        )}
      </>
      {showLogModal && (
        <OfflineFileLogModal
          show={showLogModal}
          onHide={() => {
            setSelectedSample({})
            hideModal(setShowLogModal)
          }}
          data={selectedSample}
        />
      )}
    </>
  )
}

export default withSampleConfig(ManageOfflineFilesTab)
